import React from 'react';

const Details = () => {
    return (
      <svg
        className="icon--details"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10 0C4.486 0 0 4.48606 0 10.0001C0 15.5141 4.486 20 10 20C15.514 20 20 15.5141 20 10.0001C20 4.48606 15.514 0 10 0ZM10 18.1818C5.48848 18.1818 1.81818 14.5115 1.81818 10.0001C1.81818 5.48861 5.48848 1.81818 10 1.81818C14.5115 1.81818 18.1818 5.48861 18.1818 10.0001C18.1818 14.5115 14.5115 18.1818 10 18.1818Z"
          fill="currentColor"
        />
        <path
          d="M9.9999 4.24243C9.33166 4.24243 8.78802 4.78643 8.78802 5.4551C8.78802 6.12316 9.33166 6.66667 9.9999 6.66667C10.6681 6.66667 11.2118 6.12316 11.2118 5.4551C11.2118 4.78643 10.6681 4.24243 9.9999 4.24243Z"
          fill="currentColor"
        />
        <path
          d="M9.99997 8.48486C9.49791 8.48486 9.09088 8.89189 9.09088 9.39395V14.8485C9.09088 15.3506 9.49791 15.7576 9.99997 15.7576C10.502 15.7576 10.9091 15.3506 10.9091 14.8485V9.39395C10.9091 8.89189 10.502 8.48486 9.99997 8.48486Z"
          fill="currentColor"
        />
      </svg>
    )
}

export default Details;
